import { Image } from '../../Image/Image';
import { FormattedMessage } from 'react-intl';
import Button from '@/components/Button';
import { deviceLocationType } from '@/types/data';
import { pickupHourData } from '@/utils/pickupHourData';

interface IProps {
  location: deviceLocationType;
  onClose: () => void;
  onClick: () => void;
}

export default function StoreModal({ location, onClose, onClick }: IProps) {
  const isHongdae = location === 'hongdae';

  return (
    <div className="fixed inset-0 w-screen h-screen flex flex-col bg-white z-[200]">
      <div className="w-full p-5 text-[30px] font-extrabold border-b border-[#f5f5f5]">
        <FormattedMessage id="view-store-location" defaultMessage="View store location" />
      </div>
      <div className="w-full flex justify-between px-5 pt-24">
        <div className="flex flex-col">
          <p className="text-[24px] font-bold pb-6">{`POCA SPOT ${isHongdae ? 'Hongdae' : 'Myeongdong'}`}</p>
          <p className="text-[14px] font-semibold pb-2">
            [<FormattedMessage id="store_modal_address" defaultMessage="Address" />]
          </p>
          <ul className="text-[13px] font-medium pb-6 flex flex-col gap-2">
            <p>{`· ${
              isHongdae
                ? `48-14, Wausan-ro 29-gil, Mapo-gu, Seoul (1-minute walk from Exit 7 of Hongik Univ, Station)`
                : `33, Myeongdong 8na-gil, Jung-gu, Seoul(3-minute walk from Exit 5 of Myeongdong Station)`
            }`}</p>
            {`· `}
            <FormattedMessage
              id="pick_up_notice_sub_desc_1"
              values={{
                openHour: location === 'hongdae' ? '11:00' : '10:30',
                closeHour: location === 'hongdae' ? '9:00' : '10:30'
              }}
              defaultMessage="Opening hours: Everyday, {openHour} AM to {closeHour} PM"
            />
          </ul>

          <p className="text-[14px] font-semibold pb-2">
            [<FormattedMessage id="pick_up_schedule" defaultMessage="Pick-up schedule" />]
          </p>

          <div className="w-[700px] border border-[#ededed] rounded-[10px] overflow-hidden">
            <table border={1} className="w-full rounded text-[13px] font-semibold text-center [border-style:hidden]">
              <thead>
                <tr className="bg-[#fafafa] h-[50px] font-semibold">
                  <td className="w-[120px] font-semibold" />
                  <td>
                    <FormattedMessage id="orders_before_4_hour" defaultMessage="Orders before 4:00 PM" />
                  </td>
                  <td>
                    <FormattedMessage id="orders_after_4_hour" defaultMessage="Orders after 4:00 PM" />
                  </td>
                </tr>
              </thead>
              {/* mon.- thu. */}
              <tr className="h-[50px] font-medium">
                <td className="w-[120px] font-semibold">
                  <FormattedMessage id="mon_to_thu" defaultMessage="Mon. - Thu." />
                </td>
                <td>
                  <FormattedMessage
                    id="the_same_day_hour"
                    values={{ pickupHour: pickupHourData[location].beforeFourHour }}
                    defaultMessage="{pickupHour} PM on the same day"
                  />
                </td>
                <td>
                  <FormattedMessage
                    id="tomorrow_hour"
                    values={{ pickupHour: pickupHourData[location].afterFourHour }}
                    defaultMessage="{pickupHour} PM Tomorrow"
                  />
                </td>
              </tr>
              {/* fri */}
              <tr className="h-[50px] font-medium">
                <td className="w-[120px] font-semibold">
                  <FormattedMessage id="fri" defaultMessage="Fri." />
                </td>
                <td>
                  <FormattedMessage
                    id="the_same_day_hour"
                    values={{ pickupHour: pickupHourData[location].beforeFourHour }}
                    defaultMessage="{pickupHour} PM on the same day"
                  />
                </td>
                <td>
                  <FormattedMessage
                    id="tomorrow_hour"
                    values={{ pickupHour: pickupHourData[location].beforeFourHour }}
                    defaultMessage="{pickupHour} PM Tomorrow"
                  />
                </td>
              </tr>
              {/* sat */}
              <tr className="h-[50px] font-medium">
                <td className="w-[120px] font-semibold">
                  <FormattedMessage id="sat" defaultMessage="Sat." />
                </td>
                <td>
                  <FormattedMessage
                    id="the_same_day_hour"
                    values={{ pickupHour: pickupHourData[location].beforeFourHour }}
                    defaultMessage="{pickupHour} PM on the same day"
                  />
                </td>
                <td>
                  <FormattedMessage
                    id="tomorrow_hour"
                    values={{ pickupHour: pickupHourData[location].beforeFourHour }}
                    defaultMessage="{pickupHour} PM Tomorrow"
                  />
                </td>
              </tr>
              {/* sun */}
              <tr className="h-[50px] font-medium">
                <td className="w-[120px] font-semibold">
                  <FormattedMessage id="sun" defaultMessage="Sun." />
                </td>
                <td>
                  <FormattedMessage
                    id="the_same_day_hour"
                    values={{ pickupHour: pickupHourData[location].beforeFourHour }}
                    defaultMessage="{pickupHour} PM on the same day"
                  />
                </td>
                <td>
                  <FormattedMessage
                    id="tomorrow_hour"
                    values={{ pickupHour: pickupHourData[location].afterFourHour }}
                    defaultMessage="{pickupHour} PM Tomorrow"
                  />
                </td>
              </tr>
            </table>
          </div>
          <p className="mt-6 text-[#808080] text-[14px] font-semibold">
            ※ <FormattedMessage id="store-modal-table-desc" defaultMessage="We will hold the item for three days." />
          </p>
        </div>
        <Image
          className="mt-10"
          src={isHongdae ? '/images/hongdae-barcode.png' : '/images/myeongdong-barcode.png'}
          alt="hongdae-barcode-img"
          width={740}
          height={410}
        />
      </div>
      <div className="w-full flex justify-center fixed bottom-[60px] gap-4">
        <Button textColor="black" className="bg-[#f5f5f5]" onClick={onClose}>
          Cancel
        </Button>
        <Button data-primary onClick={onClick}>
          Confirm
        </Button>
      </div>
    </div>
  );
}
